import React from "react";
import Section from "./Section";

const faqData = [
  {
    question: "Aidat+ nedir?",
    answer:
      "Aidat+, site ve apartman yöneticileri için aidat, ödeme ve kullanıcı yönetimini kolaylaştıran modern bir platformdur.",
  },
  {
    question: "Kullanıcı olarak nasıl kayıt olabilirim?",
    answer:
      "Sisteme kayıt olmak için öncelikle kişisel bilgilerinizi girip, bağlı olduğunuz site veya apartmanı seçmeniz gerekmektedir.",
  },
  {
    question: "Site yöneticisi olmanın şartları nelerdir?",
    answer:
      "Site yöneticisi olabilmek için ilgili siteye atanmış olmanız gerekir. Yetkiniz yoksa sisteme erişim sağlayamazsınız.",
  },
  {
    question: "Daire yöneticisi nasıl atanır?",
    answer:
      "Daire yöneticisi sadece kendisine atanmış daireleri yönetebilir. Bu atama SUPERADMIN veya ADMIN tarafından yapılır.",
  },
  {
    question: "Ödemelerimi nasıl takip edebilirim?",
    answer:
      "Ödemelerinizi kullanıcı panelinizde görebilir, geçmiş ödemelerinizi inceleyebilir ve ödeme tarihlerini kontrol edebilirsiniz.",
  },
  {
    question: "Aidat+ ticari projelerde kullanılabilir mi?",
    answer:
      "Evet, Aidat+ ticari ve kişisel projelerde kullanılabilir. Lisans koşullarını inceleyerek kullanım sağlayabilirsiniz.",
  },
];

export default function FAQ() {
  return (
    <Section id="faq" className="ud-faq">
      <div className="shape">
        <img src="assets/images/faq/shape.svg" alt="shape" />
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="ud-section-title text-center mx-auto">
              <span>Sıkça Sorulan Sorular</span>
              <h2>Aidat+ Hakkında Merak Ettikleriniz</h2>
              <p>
                Site ve apartman yönetimi, aidatlar, ödemeler ve kullanıcı
                yönetimi hakkında sıkça sorulan soruların yanıtlarını burada
                bulabilirsiniz.
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          {faqData.map((faq, index) => (
            <div className="col-lg-6" key={index}>
              <div
                className="ud-single-faq wow fadeInUp"
                data-wow-delay={`${0.1 * (index + 1)}s`}
              >
                <div className="accordion">
                  <button
                    className="ud-faq-btn collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${index}`}
                  >
                    <span className="icon flex-shrink-0">
                      <i className="lni lni-chevron-down"></i>
                    </span>
                    <span>{faq.question}</span>
                  </button>
                  <div
                    id={`collapse${index}`}
                    className="accordion-collapse collapse"
                  >
                    <div className="ud-faq-body">{faq.answer}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
